<header class="top-bar" [ngStyle]="{'background-color': headerStyles.backgroundColor}">
    <div class="container-responsive">
        <div class="d-flex items-center">
            <a [routerLink]="['/']" class="brother-logo">
                <img src="./assets/img/logo_brother.svg" alt="Brother logo" [ngStyle]="{'filter': headerStyles.logoFilter}">
            </a>
            <h1 class="m-auto" (click)="runTestAction()" [ngStyle]="{'color': headerStyles.color}">Partner App</h1>
            <div class="nav-toggler" (click)="onMineMenuTogglerClicked(TrackingCalledSectionDashboardEnum.MENU)">
                <div class="my-auto" [ngStyle]="{'color': headerStyles.color}">Menü</div>
                <div class="my-auto pl-1 bigger">
                    <bd-fa name="bars" [ngStyle]="{'color': headerStyles.color}"></bd-fa>
                </div>
            </div>
        </div>
    </div>
</header>

<nav [ngClass]="menuStatus ? 'active' : 'hide'" class="navigation">
    <div class="backguard" (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_CLOSE)"></div>
    <div class="navigation-links">
        <div class="d-flex">
            <div class="closer" (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_CLOSE)">
                <bd-fa name="times"></bd-fa>
            </div>
        </div>
        <a [routerLink]="['/settings']" class="settings-link"
           (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_SETTINGS)">
            <div class="setting-icon">
                <bd-fa name="cog"></bd-fa>
            </div>
            <div class="user">
                <div class="small">Angemeldet als:</div>
                <div class="font-bolder ellipsis">{{ getUserEmail() }}</div>
            </div>
        </a>
        <ul class="links">
            <li>
                <a [routerLink]="['/dashboard']" routerLinkActive="active"
                   (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_START)">
                    <span class="my-auto">Start</span>
                </a>
            </li>

            <li>
                <a [routerLink]="['/news']" routerLinkActive="active"
                   (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_NEWS)">
                    <span class="my-auto">News</span>
                </a>
            </li>

            <li>
                <a [routerLink]="['/sales-dashboard']" routerLinkActive="active"
                   (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_SALES_DASHBOARD)">
                    <span class="my-auto">Sales Dashboard</span>
                </a>
            </li>

            <ng-container *ngIf="environment.enableOldFeatures">
                <li>
                    <a [routerLink]="['/products']"
                       routerLinkActive="active"
                       (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_PRODUCTS)">
                        <span class="my-auto">Produkte</span>
                    </a>
                </li>
            </ng-container>

            <!--            <li *ngIf="gAuthData.cspAllowed || gAuthData.cspConnectedAllowed" id="csp-section">-->
            <li *ngIf="userContextService.hasPermission([SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS])" id="csp-section">
                <a class="dropdown"
                   (click)="onMenuCollapseClicked($event, TrackingCalledSectionMenuEnum.MENU_BROTHER_PRINTSMART)">
                    <span class="my-auto">Brother MPS</span>
                </a>
                <div class="dropdown-menu">
                    <ul class="ps-dropdown">
                        <!--                        <li *ngIf="gAuthData.cspAllowed || gAuthData.isCspReadOnly">-->
                        <li *ngIf="userContextService.hasPermission(SecFEPermissionPartnerAppEnum.__PAU_CONTRACTS_CSP)">
                            <a [routerLink]="['/print-smart/csp']"
                               (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_BROTHER_PRINTSMART_PPPB)">
                                CSP
                            </a>
                        </li>
                        <li *ngIf="userContextService.hasPermission([SecFEPermissionPartnerAppEnum.PAU_CONTRACTS_CSP_CONNECTED])">
                            <a [routerLink]="['/print-smart/csp_connected']"
                               (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_BROTHER_PRINTSMART_PPPB_CONTRACTS)">
                                CSP Connected
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

            <!--            <li *ngIf="gAuthData.projectManagementAllowed">-->
            <li *ngIf="userContextService.hasPermission([SecFEPermissionPartnerAppEnum.PAU_PROJECTS])">
                <a [routerLink]="['/projects']" routerLinkActive="active"
                   (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_PROJECTS)">
                    <span class="my-auto">Projekte</span>
                </a>
            </li>

            <li *ngIf="userContextService.hasPermission([SecFEPermissionPartnerAppEnum.PAU_SERVICE])">
                <a (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_SERVICE, secureLink)">
                    <span class="my-auto">Service</span>
                </a>

                <a target="_blank" referrerpolicy="no-referrer-when-downgrade" #secureLink class="d-none"></a>
            </li>

            <li>
                <a [routerLink]="['/document-basket']" routerLinkActive="active"
                   (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_DOCUMENT_BASKET)">
                    <span class="my-auto">Dokumentenkorb</span>
                </a>
            </li>

            <ng-container *ngIf="environment.enableOldFeatures">
                <li>
                    <a [routerLink]="['/solutions']"
                       routerLinkActive="active"
                       (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_SOLUTIONS)">
                        <span class="my-auto">Lösungen</span>
                    </a>
                </li>
            </ng-container>



            <li>
                <a [routerLink]="['/contact']" routerLinkActive="active"
                   (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_CONTACT)">
                    <span class="my-auto">Kontakt</span>
                </a>
            </li>

            <li>
                <a class="dropdown" (click)="onMenuCollapseClicked($event, TrackingCalledSectionMenuEnum.MENU_MORE)">
                    <span class="my-auto">Mehr</span>
                </a>
                <div class="dropdown-menu">
                    <ul>
                        <li>
                            <a *ngIf="userContextService.hasPermission([SecFEPermissionPartnerAppEnum.MY_USER_MANAGEMENT])"
                               [routerLink]="['/user-management']" routerLinkActive="active"
                               (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_USER_MANAGEMENT)">
                                <span class="my-auto">User Management</span>
                            </a>
                        </li>

                        <li>
                            <a href="https://www.brother.de/unternehmen/nutzungsbedingungen" target="_blank"
                               (click)="onMenuItemClicked(TrackingCalledSectionMenuEnum.MENU_BROTHER_TERMS_OF_USE)">
                                Nutzungsbedingungen
                            </a>
                        </li>
                    </ul>
                </div>
            </li>



        </ul>
    </div>
</nav>
